module.exports = __webpack_public_path__ + "static/img/H24_2.3e5941b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H24_2.png
// module id = 8dFD
// module chunks = 0